import React from 'react';

import Section from "../../Section";

export default function Gifs(props) {
  return <Section>
    <a name="gifs" />
    <h1 className="h3 mdl-typography--display-1-color-contrast">Gifs</h1>
      <div className="mdl-grid">
        <div className="pb-4 mdl-cell mdl-cell--6-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone mdl-typography--display-1-color-contrast">
          <img className="skill-size" src="images/gifs/loading.gif" />
        </div>
        <div className="mdl-cell mdl-cell--6-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone mdl-typography--display-1-color-contrast">
          <img className="skill-size" src="images/gifs/vu.gif" />
        </div>
      </div>
  </Section>
}



// WEBPACK FOOTER //
// ./src/Pages/Gifs/Gifs.js